import React from 'react';
import { Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BookShipmentReview from '../PickupShipment/PickupShipmentLTL';

function RatesDrawer({
  open,
  onClose,
  bookingData
}) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        height: '100vh',
        width: { xs: '100%', sm: '80%', md: '82%', lg: '72%', xl: '60%' },
        zIndex: 1300,
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#fff',
        boxShadow: '-4px 0 24px rgba(0,0,0,0.12)',
        borderLeft: '1px solid',
        borderColor: 'divider'
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
          flexShrink: 0,
          bgcolor: '#fff',
          zIndex: 1
        }}
      >
        <IconButton
          onClick={onClose}
          size='small'
          sx={{
            bgcolor: 'primary.main',
            color: '#fff',
            '&:hover': { bgcolor: 'primary.dark' },
            width: 32,
            height: 32
          }}
        >
          <ArrowBackIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>

      {/* BookShipmentReview fills the rest, scrolls internally */}
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        <BookShipmentReview
          hideServices={true}
          location={{ state: bookingData }}
        />
      </Box>
    </Box>
  );
}

export default RatesDrawer;
